module.exports = __webpack_public_path__ + "static/media/LILL-GLOCK-Weiss.5110e560.png";